/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingIdRemarkRuleUpdateRequest
 */
export interface BookingIdRemarkRuleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleUpdateRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleUpdateRequest
     */
    bookingIdRemark?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingIdRemarkRuleUpdateRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleUpdateRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleUpdateRequest
     */
    disabled?: boolean;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingIdRemarkRuleUpdateRequest
     */
    providers?: Array<GuidIdAndLabel> | null;
}

export function BookingIdRemarkRuleUpdateRequestFromJSON(json: any): BookingIdRemarkRuleUpdateRequest {
    return BookingIdRemarkRuleUpdateRequestFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'bookingIdRemark': !exists(json, 'bookingIdRemark') ? undefined : json['bookingIdRemark'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function BookingIdRemarkRuleUpdateRequestToJSON(value?: BookingIdRemarkRuleUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'bookingIdRemark': value.bookingIdRemark,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'comment': value.comment,
        'description': value.description,
        'disabled': value.disabled,
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


